import { usePal, PalHead } from "./PalUI";

const PalObjectives = () => {
  const { c, brand, ink, dim, hair } = usePal();
  const o = c.objectives;
  return (
    <section aria-label={o.eyebrow} data-testid="pal-objectives">
      <PalHead eyebrow={o.eyebrow} title={o.title} accentLine={o.accentLine} />
      <ol className={`mt-12 pt-8 border-t grid grid-cols-1 md:grid-cols-3 gap-8 ${hair}`}>
        {o.outcomes.map((x, i) => (
          <li key={x} data-testid={`pal-objective-${i}`}>
            <span className="text-[14px] font-semibold tabular-nums" style={{ color: brand }}>0{i + 1}</span>
            <h3 className={`mt-2 text-[22px] font-semibold tracking-tight leading-snug ${ink}`}>{x}</h3>
          </li>
        ))}
      </ol>
      <ol className="mt-14 flex flex-wrap gap-x-6 gap-y-3" aria-label="Session roadmap">
        {o.roadmap.map((r, i) => (
          <li key={r} className={`text-[14px] font-medium ${dim}`} data-testid={`pal-roadmap-${i}`}>
            <span className="tabular-nums mr-1.5" style={{ color: brand }}>{i + 1}</span>{r}
          </li>
        ))}
      </ol>
    </section>
  );
};

export default PalObjectives;
